// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bfx_a bhb_un bhb_cw bhb_a","MenuItem__Btn":"bfx_b bhb_z"};